export const CANCEL_MEMBER_REQUEST_START =
  'CANCEL_MEMBER_REQUEST_START';
export const CANCEL_MEMBER_REQUEST_SUCCESS =
  'CANCEL_MEMBER_REQUEST_SUCCESS';
export const CANCEL_MEMBER_REQUEST_ERROR =
  'CANCEL_MEMBER_REQUEST_ERROR';
export const CANCEL_MEMBER_REQUEST_END = 'CANCEL_MEMBER_REQUEST_END';
